import React from 'react';
import './EmptyCart.css';
import { FaShoppingBag } from 'react-icons/fa';

const EmptyCart = () => {
  return (
    <div className='card-container'>
      <div className='empty-cart'>
        <div className='empty-cart-icon'>
          <svg width="80" height="80" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.5 7.67001V6.70001C7.5 4.45001 9.31 2.24001 11.56 2.03001C14.24 1.77001 16.5 3.88001 16.5 6.51001V7.89001" stroke="#ccc" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M9 22H15C19.02 22 19.74 20.39 19.95 18.43L20.7 12.43C20.97 9.99 20.27 8 16 8H8C3.73 8 3.03 9.99 3.3 12.43L4.05 18.43C4.26 20.39 4.98 22 9 22Z" stroke="#ccc" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M15.4955 12H15.5045" stroke="#ccc" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M8.49451 12H8.50349" stroke="#ccc" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </div>
        <h2>Sepetiniz Boş</h2>
        <p>Sepetinizde ürün bulunmamaktadır.</p>
        <p className="empty-cart-message">Ürünleri sepetinize ekleyerek alışverişe başlayabilirsiniz.</p>
        <a href="/" className="shop-now-button">
          <FaShoppingBag style={{ marginRight: '8px' }} />
          Alışverişe Başla
        </a>
      </div>
    </div>
  );
};

export default EmptyCart; 